import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowRight"><Path fillRule="evenodd" clipRule="evenodd" d="M14 4.48224L21.5178 12L14 19.5178L12.2322 17.75L16.7322 13.25H3V10.75H16.7322L12.2322 6.25001L14 4.48224Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRight;
